import { ReactNode } from "react";
import {
    BookOutlined,
    DollarCircleOutlined,
    EuroCircleOutlined,
    ReadOutlined,
    SettingOutlined,
    TeamOutlined,
    UserOutlined,
} from "@ant-design/icons";

export interface NavItem {
    key: string;
    label: string;
    icon?: ReactNode;
    path?: string;
    state?: unknown;
    children?: NavItem[];
}

export interface NavGroup {
    label?: string;
    items: NavItem[];
}

const adminGroups = (): NavGroup[] => [
    {
        label: "Gestion",
        items: [
            {
                key: "coursArabes",
                label: "Cours arabes",
                icon: <ReadOutlined />,
                children: [
                    { key: "adminCoursAdultes", label: "Adultes", path: "/adminCours", state: { application: "COURS_ADULTE" } },
                    { key: "adminCoursEnfants", label: "Enfants", path: "/adminCours", state: { application: "COURS_ENFANT" } },
                ],
            },
            { key: "adminAdhesion", label: "Adhésions", icon: <EuroCircleOutlined />, path: "/adminAdhesion" },
            {
                key: "classesMenu",
                label: "Classes",
                icon: <TeamOutlined />,
                children: [
                    { key: "creerModifierClasse", label: "Créer ou modifier", path: "/creerModifierClasse" },
                    { key: "classes", label: "Mes classes", path: "/classes" },
                ],
            },
        ],
    },
    {
        label: "Configuration",
        items: [
            { key: "adminTarif", label: "Tarifs", icon: <DollarCircleOutlined />, path: "/adminTarif" },
            { key: "parametres", label: "Paramètres", icon: <SettingOutlined />, path: "/parametres" },
        ],
    },
    {
        label: "Administration",
        items: [{ key: "utilisateurs", label: "Utilisateurs", icon: <UserOutlined />, path: "/utilisateurs" }],
    },
];

const enseignantGroups = (): NavGroup[] => [
    { items: [{ key: "classes", label: "Mes classes", icon: <TeamOutlined />, path: "/classes" }] },
];

const tresorierGroups = (): NavGroup[] => [
    { items: [{ key: "adminAdhesion", label: "Adhésions", icon: <EuroCircleOutlined />, path: "/adminAdhesion" }] },
];

const utilisateurGroups = (): NavGroup[] => [
    { items: [{ key: "mesInscriptions", label: "Mes inscriptions", icon: <BookOutlined />, path: "/mesInscriptions" }] },
];

export const getNavGroups = (roles: string[]): NavGroup[] => {
    const groups: NavGroup[] = [];
    const seen = new Set<string>();
    const registerKeys = (item: NavItem) => {
        seen.add(item.key);
        item.children?.forEach(registerKeys);
    };
    const add = (candidates: NavGroup[]) => {
        candidates.forEach((group) => {
            const items = group.items.filter((item) => {
                if (seen.has(item.key)) return false;
                registerKeys(item);
                return true;
            });
            if (items.length > 0) groups.push({ ...group, items });
        });
    };
    if (roles.includes("ROLE_ADMIN")) add(adminGroups());
    if (roles.includes("ROLE_ENSEIGNANT")) add(enseignantGroups());
    if (roles.includes("ROLE_TRESORIER")) add(tresorierGroups());
    if (roles.includes("ROLE_UTILISATEUR")) add(utilisateurGroups());
    return groups;
};

const PAGE_TITLES: Record<string, string> = {
    "/": "Accueil",
    "/adminCours": "Cours arabes",
    "/adminAdhesion": "Adhésions",
    "/adminTarif": "Tarifs",
    "/parametres": "Paramètres",
    "/creerModifierClasse": "Classes",
    "/classes": "Mes classes",
    "/utilisateurs": "Utilisateurs",
    "/mesInscriptions": "Mes inscriptions",
    "/changePassword": "Mot de passe",
};

export const getPageTitle = (pathname: string): string =>
    PAGE_TITLES[pathname] ?? "Association Musulmane du Chablais";
